import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { Prefs } from "~/alias/prefs";
import * as logger from "~/utilities/background";
async function applyOptOut() {
    const isOptedOut = Prefs.get("data_collection_opt_out");
    await ewe.cdp.setOptOut(typeof isOptedOut === "boolean" ? isOptedOut : true);
}
export async function start() {
    try {
        await Prefs.untilLoaded;
        await applyOptOut();
        Prefs.on("data_collection_opt_out", applyOptOut);
    }
    catch (error) {
        logger.reportAndLogError(error, "CDP initialization failed");
    }
}
